module.exports = __webpack_public_path__ + "img/ticket-pattern-2.6ec2ae04.svg";